import { jsx as i } from "react/jsx-runtime";
import { HorizonContext as e } from "./Horizon.context.js";
const t = ({
  svgBaseURL: o,
  children: r
}) => /* @__PURE__ */ i(
  e.Provider,
  {
    value: {
      svgBaseURL: o
    },
    children: r
  }
);
t.displayName = "HorizonProvider";
export {
  t as HorizonProvider
};
